package com.merkost.handpass.admin.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.window
import org.w3c.dom.events.Event
import org.w3c.dom.events.EventListener
import androidx.compose.runtime.DisposableEffect

enum class ViewportMode { Wide, Compact, Mobile }

val LocalViewportMode = compositionLocalOf<ViewportMode> { ViewportMode.Wide }

@Composable
fun rememberViewportMode(): ViewportMode {
    var mode by remember { mutableStateOf(currentViewportMode()) }

    DisposableEffect(Unit) {
        val mediaWide = window.matchMedia("(min-width: 1024px)")
        val mediaCompact = window.matchMedia("(min-width: 768px) and (max-width: 1023px)")

        val listener = EventListener { _: Event -> mode = currentViewportMode() }

        mediaWide.addEventListener("change", listener)
        mediaCompact.addEventListener("change", listener)

        onDispose {
            mediaWide.removeEventListener("change", listener)
            mediaCompact.removeEventListener("change", listener)
        }
    }

    return mode
}

private fun currentViewportMode(): ViewportMode {
    val width = window.innerWidth
    return when {
        width >= 1024 -> ViewportMode.Wide
        width >= 768 -> ViewportMode.Compact
        else -> ViewportMode.Mobile
    }
}
